import { render, staticRenderFns } from "./headerPreviewSteps.vue?vue&type=template&id=3c6fd2d4&scoped=true&"
import script from "./headerPreviewSteps.vue?vue&type=script&lang=js&"
export * from "./headerPreviewSteps.vue?vue&type=script&lang=js&"
import style0 from "./headerPreviewSteps.vue?vue&type=style&index=0&lang=css&"
import style1 from "./headerPreviewSteps.vue?vue&type=style&index=1&id=3c6fd2d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6fd2d4",
  null
  
)

export default component.exports